import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../../components/PromoIconography/MessageIcon/MessageIcon.module.scss';
const MessageIcon = ({ display, message, theme }) => {
    if (!display || !message)
        return null;
    const messageTheme = styles[theme] || styles.default;
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement("span", { className: messageTheme, "data-testid": "message-icon" }, message)));
};
MessageIcon.displayName = 'MessageIcon';
MessageIcon.defaultProps = {
    display: false,
    message: undefined,
    theme: undefined,
};
MessageIcon.propTypes = {
    display: PropTypes.bool,
    message: PropTypes.string,
    theme: PropTypes.string,
};
export default MessageIcon;
//# sourceMappingURL=index.js.map